export default __webpack_public_path__ + "static/media/symptomatic_ecg.09380147.svg";